






























































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';

import { get } from 'vuex-pathify';
import { Quote } from '@/models/quote';

import { CurrencyRate } from '@/models/currency';

export default Vue.extend({
  name: 'QuoteVentilationSummaryDetailList',

  props: {
    quote: { type: Object as PropType<Quote> }
  },

  computed: {
    getCurrencyById: get<(id: number) => CurrencyRate>(
      'currency/getCurrencyById'
    ),

    displayVentilationSummary() {
      return this.quote.rooms.length > 0 || this.quote.capacity != null;
    }
  },

  methods: {
    roundCapacityValue(value: string) {
      return Number.parseFloat(value).toFixed(1);
    }
  }
});
